import styled from 'styled-components';
import NavLink from '../../../global/NavLink';

const MobileBreakPoint = '600px';

export const Container = styled.div`
  margin-bottom: 92px;
`;

export const InnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${p => p.theme.media.largePhone} {
    flex-direction: column;
  }
`;

export const FlexColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: calc(100% / 3);

  @media ${p => p.theme.media.largePhone} {
    width: 100%;
  }
`;

export const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;

  ${FlexColumn} {
    width: 50%;
  }

  @media (min-width: ${MobileBreakPoint}) {
    justify-content: space-around;
    width: calc(100% * (2 / 3));
  }
`;

export const Heading = styled.h2`
  font-family: ${p => p.theme.font.metaOt};
  font-size: 28px;
  line-height: 32px;
  text-transform: uppercase;
`;

export const HeadingSpan = styled.span`
  color: ${p => p.theme.color.primary};
`;

export const HeadingBody = styled.p`
  color: ${p => p.theme.color.textPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;
  font-weight: ${p => p.theme.fontWeight.regular};
  line-height: 24px;
  text-transform: initial;
`;

export const StyledNavLink = styled(NavLink)`
  flex: 0 0 auto;
  width: 148px;
`;

export const ProductHeading = styled.h3`
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 18px;
  font-weight: ${p => p.theme.fontWeight.bold};
  max-width: 372px;
  min-height: 72px;
  text-align: center;
  text-transform: uppercase;
`;

export const ImageWrapper = styled.div`
  max-height: 325px;
`;

export const Image = styled.img`
  max-height: 325px;
  min-height: 140px;
  object-fit: contain;
  width: 100%;
  height: auto;

  @media (max-width: ${MobileBreakPoint}) {
    height: 100%;
  }
`;

export const Desktop = styled.div`
  @media ${p => p.theme.media.largePhone} {
    display: none;
  }
`;

export const Mobile = styled.div`
  display: none;
  @media ${p => p.theme.media.largePhone} {
    display: block;
  }
`;

export const SpecsHeading = styled.h2`
  border-bottom: 1px solid ${p => p.theme.color.borderPrimaryDarkened};
  color: ${p => p.theme.color.textPrimary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;
  padding-bottom: 8px;
  width: 100%;
`;

export const MobileSpecs = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 30px 0 40px 0;
  width: 100%;

  div,
  span {
    width: 50%;
  }

  span {
    color: ${p => p.theme.color.textPrimary};
    display: block;
    font-family: ${p => p.theme.font.sourceSans};
    font-size: 16px;
    text-align: center;
  }

  a {
    cursor: default;

    svg {
      margin: auto;
    }
  }
`;

export const TableHeader = styled.div`
  background-color: ${p => p.theme.color.borderPrimaryOverlay};
  color: ${p => p.theme.color.tertiary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 18px;
  font-weight: ${p => p.theme.fontWeight.bold};
  padding: 10px 32px;
  text-transform: uppercase;
  width: 100%;
`;

export const TableGrid = styled.div`
  display: grid;
  color: ${p => p.theme.color.textPrimary};
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr auto;
`;

export const Cell = styled.div`
  background-color: ${p =>
    p.type === 'heading' ? p.theme.color.offWhite : p.theme.color.tertiary};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 16px;
  font-weight: ${p =>
    p.type === 'heading'
      ? p.theme.fontWeight.bold
      : p.theme.fontWeight.regular};
  padding: 16px 32px;
  text-align: ${p => (p.type === 'heading' ? 'initial' : 'center')};

  :nth-of-type(-n + 3) {
    padding-top: 32px;
  }

  :nth-of-type(n + 28) {
    padding-bottom: 32px;
  }

  a {
    cursor: default;

    svg {
      margin: auto;
    }
  }
`;
